module.exports = __webpack_public_path__ + "static/media/patalo_see_dirgha.14ecddf0.ogg";